import { TutorialsStoreState } from '../models/tutorials.types'

export const reducers = {
  setTutorials: (state: TutorialsStoreState, { payload }: any) => ({
    ...state,
    tutorials: payload,
    lastFetchedAt: Date.now(),
  }),
  setTutorial: (state: TutorialsStoreState, { payload }: any) => ({
    ...state,
    currentTutorial: payload,
  }),
}
